module.exports = __webpack_public_path__ + "static/media/lounge.242f3fe5.svg";